import ErrorStackParser from 'error-stack-parser';
import Modal from "root/Modals/VanillaModal/VanillaModal";

import "root/Modals/VanillaModal/Modal.scss" ;
import format from "date-fns/format";

export const Globals = (function()
{
    const APIFolder = '/api/v1.0';

    function Globals() {
    }

    Object.defineProperty(Globals, "APIFolder", {
        get: function() {
            return 'https://' + document.location.hostname + APIFolder;
        },
    });

    Object.defineProperty(Globals, "BaseURL", {
        get: function() {
            return 'https://' + document.location.hostname ;
        },
    });

    return Globals;
})();

export const getDataWithPromise = (url, type, data, authToken)  =>
{
    return new Promise((resolve, reject) =>
    {
        if ( url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            let params = {
                type: type,
                url: url,
                data: data,
                success: (data) =>
                {
                    if (checkError(data))
                    {
                        resolve ( data );
                    }
                },
                error: (jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                }
            }

            if ( authToken !== undefined )
            {
                params = { ...params, headers: {"Authorization": 'Bearer ' + authToken }} ;
            }

            $.ajax( params );
        }
    });
}

export const urlExplode = (template, params) =>
{
    let rval = template;

    for (const [key, value] of Object.entries(params))
    {
        rval = rval.replace('{' + key + '}', value);
    }

    return rval;
}

/**
 * Returns a list of parameters formatted for passing as parameters on a URL
 *
 * Can be called with a single string, and array of string valus OR an object of key value pairs:
 *
 * E.g.
 *
 *      const params = getParamList ( 'include-teacher' ) ;
 *
 * or
 *
 *      const params = getParamList ( [ 'include-teacher', 'include-providers' ] ;
 *
 * or
 *
 *      const params = getParamLIst ( { 'include-teacher' : true, max: 12 } ) ;
 *
 * @params {String | Object | Array} flagArray  Array or string objects to be added to the list
 * @params {string} initialJoin ? or & depending on what you want the join character to be
 *
 * @return {String}
 */
export const getParamList = (flagArray, initialJoin) =>
{
    let curJoin = initialJoin === undefined || initialJoin === '?' ? '?' : '&';

    if ( flagArray === undefined )
    {
        return '' ;
    }
    else if (typeof flagArray === 'string')
    {
        // If it's just a single string value, just append it
        return curJoin + flagArray ;
    }
    else if (Array.isArray(flagArray))
    {
        // If it's an array, return an array of the names
        return flagArray.reduce((accumulator, currentValue, currentIndex, array) =>
        {
            const add = accumulator + curJoin + currentValue;

            curJoin = '&';

            return add;
        }, '');
    }
    else
    {
        // We can also pass an object if key-values are required

        const keys = Object.keys(flagArray);
        const values = Object.values(flagArray);

        return keys.reduce((accumulator, currentValue, currentIndex, array) =>
        {
            const v = currentValue + '=' + values[currentIndex];

            const add = accumulator + curJoin + v;

            curJoin = '&';

            return add;
        }, '');

    }

}
export const checkError = (data) =>
{
    if (data != null)
    {
        if (responseHasStatusElement(data))
        {
            if (getResultFromResponse(data) === SUCCESS_STATUS)
            {
                return true;
            }
            else
            {
                console.error ( data ) ;

                let displayMessage = '';

                const type = getExceptionClassFromResponse(data)

                if ( type !== null )
                {
                    // This is a new type of error with exception type so we can make some more specific decisions

                    const stackTrace = getStackTraceFromResponse( data ) ;

                    if ( type.includes ( '\\APIAuthorisationException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let callingFunctionDetails = stackTrace[0];

                        let callingFilename = callingFunctionDetails.file ;
                        let callingFunctionName = callingFunctionDetails.function ;
                        let callingFunctionLine = callingFunctionDetails.line ;

                        if ( callingFunctionDetails.function === 'checkRights' )
                        {
                            // If we were called from checkRights, the actual culprit is the next level down
                            callingFunctionDetails = stackTrace[1] ;
                            callingFunctionName = callingFunctionDetails.function ;
                        }

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>Authorisation Failed</b></p>';
                    }
                    else if ( type.includes ( '\\APIParameterException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let detail = getErrorDetailromResponse(data) ;
                        let stackOff = 0 ;

                        if ( stackTrace[stackOff].function === 'checkArgs')
                        {
                            stackOff = 1;
                        }

                        let callingFilename = stackTrace[0].file ;
                        let callingFunctionName = stackTrace[stackOff].function ;
                        let callingFunctionLine = stackTrace[0].line ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + detail.message + '</b></p>';
                    }
                    else if ( type.includes ( 'PDOException'))
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let pdoDetail = getErrorDetailromResponse(data) ;

                        let callingFunctionDetails = stackTrace[1];

                        if ( callingFunctionDetails.function === 'bindAndExecute')
                        {
                            callingFunctionDetails = stackTrace[2] ;
                        }

                        const callingFilename = pdoDetail.file ;
                        const callingFunctionName = callingFunctionDetails.function ;
                        const callingFunctionLine = pdoDetail.line ;
                        const message = pdoDetail.message ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + message + '</b></p>';
                    }
                    else if ( type === 'Error')
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let detail = getErrorDetailromResponse(data) ;

                        let callingFunctionDetails = stackTrace[0];

                        let callingFilename = detail.file ;
                        let callingFunctionName = callingFunctionDetails.function ;
                        let callingFunctionLine = detail.line ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + detail.message + '</b></p>';
                    }
                    else if ( type === 'Exception' || type === 'RuntimeException' )
                    {
                        // We need to inspect the stack to see where the error actually occurred

                        let exceptionDetail = getErrorDetailromResponse(data) ;

                        let exceptionCallingFunctionDetails = stackTrace[0];

                        let callingFilename = exceptionCallingFunctionDetails.file ;
                        let callingFunctionName = exceptionCallingFunctionDetails.function ;
                        let callingFunctionLine = exceptionCallingFunctionDetails.line ;

                        displayMessage = "<p>Error File: " + callingFilename + '</p>';
                        displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                        displayMessage += '<p><b>' + exceptionDetail.message + '</b></p>';
                    }
                }
                else if (getErrorFromResponse(data) === "PDO Exception")
                {
                    const details = getErrorDetailFromResponse(data);

                    displayMessage = "<p>Error File: " + details.file + '</p>';
                    displayMessage += "<p>Error Line: " + details.line + '</p>';
                    displayMessage += '<p>' + details.message + '</p>';
                }
                else if (getErrorFromResponse(data) === "Exception")
                {
                    const details = getErrorDetailFromResponse(data);

                    displayMessage = "<p>Error File: " + details.file + '</p>';
                    displayMessage += "<p>Error Line: " + details.line + '</p>';
                    displayMessage += '<p>' + details.message + '</p>';
                }
                else if (getErrorFromResponse(data) === "Invaild JWT Token")
                {
                    const emailContact = '<a href="mailto:info@seven360.co.uk">info@seven360.co.uk</a>'
                    displayMessage = "<p>Invalid Token: Your security token has expired. Please contact the person who invited you to login. Or email  " + emailContact + '</p>';
                }
                else
                {
                    displayMessage = "<p>Error: " + data.error + "</p>";
                    displayMessage += "<p>Detail: " + data.errorDetail + "</p>";
                }

                const myModal = new Modal({
                    title: 'The Operation Failed',
                    content: displayMessage,
                    buttons: Modal.buttons.alert
                }).show();
            }
        }
        else
        {
            const regex = /^.*(status).*$/mg;
            const jsonBit = data.match(regex);

            let msg = '';
            let fullMessage = '';

            if (jsonBit === null)
            {
                fullMessage = data;
            }
            else
            {
                const obj = JSON.parse(jsonBit[0]);

                fullMessage = "Error occurred in " + obj.status.errorDetail.file + "<br/>";
                fullMessage += "Line " + obj.status.errorDetail.line + "<br/>";
                fullMessage += "Message " + obj.status.errorDetail.message + "<br/>";
            }

            const myModal = new Modal({
                title: 'The Operation Failed',
                content: fullMessage,
                buttons: Modal.buttons.alert
            }).show();
        }
    }
    else
    {
        const myModal = new Modal({
            title: 'The Operation Failed',
            content: 'Null Response From Server',
            buttons: Modal.buttons.alert
        }).show();
    }

    return false;
}

/* export const checkError = ( data ) =>
{
    if ( data != null )
    {
        var status = data.status ;

        if ( status != null )
        {
            //console.log ( status ) ;

            if ( status.result == 'success' )
            {
                return true ;
            }
            else
            {
                if ( status.error == "PDO Exception")
                {
                    var displayMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                    displayMessage += "<p>Error Line: " + status.errorDetail.line + '</p>' ;
                    displayMessage += '<p>' + status.errorDetail.message + '</p>' ;
                }
                else if ( status.error == "Exception")
                {
                    var displayMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                    displayMessage += "<p>Error Line: " + status.errorDetail.line + '</p>' ;
                    displayMessage += '<p>' + status.errorDetail.message + '</p>' ;
                }
                else
                {
                    var displayMessage = "<p>Error: " +status.error + "</p>" ;
                    displayMessage += "<p>Detail: " +status.errorDetail + "</p>" ;
                }

                bootbox.alert({
                    size: "large",
                    title: "The operation failed",
                    message: displayMessage,
                    callback: function()
                    {
                    }
                })
            }
        }
        else
        {
            bootbox.alert({
                size: "large",
                title: "The operation failed",
                message: "Null Response From Server",
                callback: function()
                {
                }
            })
        }
    }
    else
    {
        bootbox.alert({
            size: "large",
            title: "The operation failed",
            message: "Null Response from server",
            callback: function()
            {
            }
        })
    }

    return false ;
}
*/

function getThisErrorObject()
{
    try
    {
        throw Error('')
    }
    catch(err)
    {
        const res = ErrorStackParser.parse(err);

        return res;
    }
}

export const handleAjaxError = (jqXHR, exception, error, returnUrl) =>
{
    let msg = '' ;
    let fullMessage = '' ;

    if ( jqXHR.status === 0 || jqXHR.readyState === 0)
    {
        return;
    } ;

    if (jqXHR.status === 0)
    {
        msg = 'Not connect.\n Verify Network.';
    }
    else if (jqXHR.status == 400)
    {
        msg = 'Bad Parameters. [400]' + '</p>' ;

        if ( jqXHR.responseJSON != null )
        {
            const status = jqXHR.responseJSON ;

            if ( status.error === "Exception")
            {
                fullMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                fullMessage += "<p>Error Line: " + status.errorDetail.line + '</p>' ;
                fullMessage += '<p>' + status.errorDetail.message + '</p>' ;
            }
        }
    }
    else if (jqXHR.status == 404)
    {
        if ( jqXHR.responseJSON != null )
        {
            const status = jqXHR.responseJSON ;

            if ( status.error == "Exception")
            {
                fullMessage = "<p>Error URL: " + status.errorDetail.file + '</p>';
                fullMessage += '<p>' + status.errorDetail.message + '</p>' ;
            }
        }
        else
        {
            msg = 'Page Not Found. [404]' + '</p>' ;
        }
    } else if (jqXHR.status == 401) {
        msg = 'Not Authorised. [404]';
    } else if (jqXHR.status == 500) {
        msg = 'Internal Server Error [500].';

        if ( jqXHR.responseJSON != null )
        {
            const status = jqXHR.responseJSON ;

            if ( status.error === "Exception")
            {
                fullMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                fullMessage += "<p>Error Line: " + status.errorDetail.line + '</p>' ;
                fullMessage += '<p>' + status.errorDetail.message + '</p>' ;
            }
        } else if ( jqXHR.responseText != null )
        {
            fullMessage = "<p>Error File: " + jqXHR.responseText + '</p>';
        }
    } else if (exception === 'parsererror') {
        msg = 'Requested JSON parse failed.';
    } else if (exception === 'timeout') {
        msg = 'Time out error.';
    } else if (exception === 'abort') {
        msg = 'Ajax request aborted.';
    } else {
        if ( jqXHR.message != null )
        {
            msg = jqXHR.message ;

            fullMessage = "<p>Error Stack: " + jqXHR.stack + '</p>';
        }
        else
        {
            msg = 'Uncaught Error.\n' + jqXHR.responseText;
        }
    }

    const stackFrames = getThisErrorObject() ;

    const callingFrame = stackFrames[2] ;

    if ( fullMessage === '' )
    {
        fullMessage = "Error occurred in function " + callingFrame.functionName + " in module " + callingFrame.fileName + " at line " + callingFrame.lineNumber ;
    }

    if ( jqXHR.status == 401 )
    {
        fullMessage = "You are not authorised to perform this operation."
    }

    bootbox.alert({
        size: "large",
        title: "The operation failed " + msg,
        message: fullMessage,
        callback: function()
        {
            if ( returnUrl != null )
            {
                location.assign(returnUrl);
            }
        }
    });
}

export const getDataFromResponse = ( response ) =>
{
    if ( response.data !== undefined && response.data!= null )
    {
        return response.data ;
    }
    else
    {
        return [] ;
    }
}

export const getCustomDataFromResponse = ( response ) =>
{
    if ( response.custom_data !== undefined && response.custom_data!= null )
    {
        return response.custom_data ;
    }
    else
    {
        return  null ;
    }
}

export const responseHasCustomData = ( response ) =>
{
    if ( response.custom_data !== undefined && response.custom_data!= null )
    {
        return true;
    }
    else
    {
        return false ;
    }
}

export const getNamedCustomDataFromResponse = (response, itemName) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if ( response.custom_data !== undefined )
        {
            if ( response.custom_data[itemName] !== undefined )
            {
                return response.custom_data[itemName] ;
            }
            else
            {
                return [] ;
            }
        }
        else
        {
            return [] ;
        }
    }
    else
    {
        return [];
    }
}

export const getInsertIdFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if (response.status.insertId !== undefined)
        {
            return response.status.insertId;
        }
        else
        {
            return null
        }
    }
    else
    {
        return null;
    }
}

export const getNumRowsFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return +response.status.rowsAffected;
    }
    else
    {
        return 0;
    }
}

export const SUCCESS_STATUS = 'success';
export const FAIL_STATUS = 'fail';

export const getStatusFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status;
    }
    else
    {
        return null;
    }
}

export const getResultFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status.result;
    }
    else
    {
        return null;
    }
}

export const getErrorDetailromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        return response.status.errorDetail;
    }
    else
    {
        return null;
    }
}

export const getErrorFromResponse = (response) =>
{
    return response.status.error;
}

export const getExceptionClassFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if ( response.status.exceptionClass !== undefined )
        {
            return response.status.exceptionClass;
        }
        else {
            return null ;
        }
    }
    else
    {
        return null;
    }
}

export const getStackTraceFromResponse = (response) =>
{
    if (response.status !== undefined && response.status != null)
    {
        if ( response.status.errorDetail.trace !== undefined )
        {
            return response.status.errorDetail.trace;
        }
        else {
            return null ;
        }
    }
    else
    {
        return null;
    }
}

export const getErrorDetailFromResponse = (response) =>
{
    return response.status.errorDetail;
}

export const responseHasStatusElement = (response) =>
{
    return response.status !== undefined;
}

export const getEncryptedInsertIdFromResponse = ( response ) =>
{
    return response.status.encInsertId ;
}

export const generalBootboxAlert = ( title, message, callback ) =>
{
    if ( callback === null || callback === undefined )
    {
        bootbox.alert({
            size: "large",
            title: title,
            message: message
        });
    }
    else
    {
        bootbox.alert({
            size: "large",
            title: title,
            message: message,
            callback: function()
            {
                callback();
            }
        });
    }
}

const rvals = (obj) =>
{
    for (const [key, value] of Object.entries(obj))
    {
        if ( value instanceof Date)
        {
            obj[key] =  format(value, 'dd/MM/yyyy HH:mm')
        }
        else
        {
            obj[key] = value ;
        }
    }
}

export const preProcessForm = ( formData ) =>
{
    for (const [key, value] of Object.entries(formData))
    {
        rvals ( value ) ;
    }
}